import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { VendorsList } from 'src/app/shared/models/app-models/SourcingOutcome.model';
import { Input } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { DropDownOptions } from 'src/app/shared/models/app-models';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MY_DATE_FORMAT } from 'src/app/data/constants/Data';

@Component({
  selector: 'app-sourcing-outcome',
  templateUrl: './sourcing-outcome.component.html',
  styleUrls: ['./sourcing-outcome.component.scss'],
  providers: [{ provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
  { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMAT }],
})

export class SourcingOutcomeComponent implements OnInit {
  @Input() vendorList: VendorsList[] = []; // Receive data from Parent rfq-summary.component.ts and .html
  @Input() reasonForNoQuotation: DropDownOptions[] = []; // Receive data from Parent rfq-summary.component.ts and .html
  @Input() isReadOnlyRFQSummary: boolean = false;
  minDate: Date = new Date();
  sourcingOutcomeDS = new MatTableDataSource<VendorsList>([])

  columns = [
    {
      columnDef: 'VendorName',
      header: 'Vendor name',
      cell: (element: any) => element.Name,
    },
    {
      columnDef: 'QuoteReceived',
      header: 'Quote received',
      cell: (element: any) => element.Status,
    },
    {
      columnDef: 'QuoteExpiringOn',
      header: 'Quote expiring on',
      cell: (element: any) => element.QuoteExpiring,
    },
    {
      columnDef: 'ReasonForNoQuotation',
      header: 'Reason for no quotation',
      cell: (element: any) => element.ReasonForNoQuotationId,
    },
  ];

  displayedColumns = this.columns.map((c) => c.columnDef);

  constructor(private cdr: ChangeDetectorRef) { }

  ngAfterViewInit() {
    // If row.Status is updated later in the lifecycle, trigger change detection
    this.cdr.detectChanges();
  }

  ngOnInit(): void {
    this.sourcingOutcomeDS = new MatTableDataSource(this.vendorList);
  }

  get vendorsInvited(): number {
    return this.vendorList.length;
  }

  get vendorsQuoted(): number {
    return this.vendorList.filter(vendor => vendor.Status === true).length || 0;
  }

  getReason(id: string) {
    const reason = this.reasonForNoQuotation.find(item => item.id === id);
    return reason ? reason.value : null;
  }

}
